/**
 * A simple function for using Google's data layer and sending different events to it.
 * @param event - The datalayer event name
 * @param data - The event data object
 * @example
 * const MyComponent = () => {
 *   return (
 *     <button onClick={() => pushToDataLayer('eventName', {
 *       ecommerce: {
 *         click: {
 *           ...data
 *         }
 *       }
 *     })}>
 *       Clear Value
 *     </button>
 *   )
 * }
 */

export const pushToDataLayer = (
  event: string,
  data: { [key: string]: any }
) => {
  if (window.dataLayer) {
    window.dataLayer.push({
      event,
      ...data
    })
  } else {
    throw new Error('Google Tag Manager dataLayer is not defined.')
  }
}
